import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useFlags } from "launchdarkly-react-client-sdk";

import { usePermissions } from "components/Hook";
import NewPersonalInfoV2 from "./PersonalInfo/NewPersonalProfileV2";
import AdminProfile from "components/Screens/SettingV2/Profile";
import PageLoader from "components/common/PageLoader";
import TopHeader from "components/common/TopHeader";

import { ManageUser } from "store/actions/Settings/ManageUser";
import { GetCustomerUserandCompanyProfileData } from "store/actions/Settings/CustomerUser&CompanyProfileData";

function Profile() {
  const dispatch = useDispatch();
  const { loggedInUserType } = usePermissions();
  const { platformHeader } = useFlags();

  const manageUser = useSelector((state) => state.ManageUser.manageUser);
  const loadingChangeUserPassword = useSelector((state) => state.ChangeUserPassword.loadingChangeUserPassword);
  const loadingCustomeruserandCompanyProfileData = useSelector(
    (state) => state.CustomerUserandCompanyProfileData.loadingCustomeruserandCompanyProfileData
  );
  const customerUserandCompanyProfileData = useSelector(
    (state) => state.CustomerUserandCompanyProfileData.customerUserandCompanyProfileData
  );
  const loadingEditUserProfile = useSelector((state) => state.EditUserProfile.loadingEditUserProfile);

  useEffect(() => {
    let loggedInUser = {};
    let userAdditionalInfo = {};
    let manageUserRequest = "";
    let getProfileDataRequest = "";

    loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    userAdditionalInfo = JSON.parse(sessionStorage.getItem("userAdditionalInfo"));

    if (loggedInUser && Object.keys(loggedInUser).length && loggedInUser.userId) {
      if (loggedInUser?.type === "customer") {
        getProfileDataRequest = `customerUser/${loggedInUser?.userId}`;
        manageUserRequest = `customer/${userAdditionalInfo?.customerId}/customerUsers`;
      } else if (loggedInUser?.type === "edge") {
        getProfileDataRequest = `user/${loggedInUser?.userId}`;
        manageUserRequest = "users";
      }
    }

    dispatch(
      ManageUser({
        request: manageUserRequest,
        rowsPerPage: 50,
        page: 0,
        sortBy: {
          field: "First_Name",
          direction: "asc",
        },
      })
    );

    dispatch(
      GetCustomerUserandCompanyProfileData({
        request: getProfileDataRequest,
      })
    );
  }, []);

  const renderProfileContent = () => {
    if (loggedInUserType === "edge") {
      return <AdminProfile />;
    }

    if (customerUserandCompanyProfileData.ok) {
      return (
        <div className="bg-white">
          <TopHeader
            title="Profile"
            linkName="Account"
            link="Account"
            breadcrumbs={!platformHeader}
            backIcon={platformHeader ? "" : "/main/dashboard"}
          />
          <div className="profile-info-container" style={{ marginTop: platformHeader ? "20px" : "32px" }}>
            <NewPersonalInfoV2
              customerUserandCompanyProfileData={customerUserandCompanyProfileData}
              managersList={manageUser?.ok ? manageUser.payload.rows : []}
            />
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <Helmet>
        <title>Edge | Profile</title>
      </Helmet>

      {loadingChangeUserPassword || loadingCustomeruserandCompanyProfileData || loadingEditUserProfile ? (
        <PageLoader />
      ) : null}

      {renderProfileContent()}
    </>
  );
}

export default Profile;
